import { getLeafNodes } from 'next/lib/conditions';
import {
  GROUP_UPDATED,
  CLAUSE_ADDED,
  CLAUSE_UPDATED,
  CLAUSE_NEGATED,
  CLAUSE_PERMITTED,
  CLAUSE_DELETED,
  GROUP_CLAUSE_ADDED,
  GROUP_UNGROUPED,
  GROUP_DELETED,
} from './actions';

export const conditionsReducer = (conditions, { type, payload }) => {
  const [[groupType, clauses]] = Object.entries(conditions);

  switch (type) {
    case GROUP_UPDATED:
      return { [payload]: clauses };
    case CLAUSE_ADDED: {
      const [lastClause] = getLeafNodes(conditions).slice(-1);
      const [lastClauseType] = Object.keys(lastClause);
      return {
        [groupType]: [...clauses, { [lastClauseType]: {} }],
      };
    }
    case CLAUSE_UPDATED: {
      const { index, changes } = payload;
      return {
        [groupType]: [
          ...clauses.slice(0, index),
          // if an empty group is found, ensure that it is removed from the tree
          ...(changes ? (Array.isArray(changes) ? changes : [changes]) : []),
          ...clauses.slice(index + 1),
        ],
      };
    }
    case CLAUSE_NEGATED: {
      const { index } = payload;
      const {
        [index]: { not, ...restClause },
      } = clauses;
      const [clause] = not || [restClause];
      return {
        [groupType]: [
          ...clauses.slice(0, index),
          { not: [clause] },
          ...clauses.slice(index + 1),
        ],
      };
    }
    case CLAUSE_PERMITTED: {
      const { index } = payload;
      const {
        [index]: { not, ...restClause },
      } = clauses;
      const [clause] = not || [restClause];
      return {
        [groupType]: [
          ...clauses.slice(0, index),
          clause,
          ...clauses.slice(index + 1),
        ],
      };
    }
    case CLAUSE_DELETED: {
      const { index } = payload;
      return {
        [groupType]: [...clauses.slice(0, index), ...clauses.slice(index + 1)],
      };
    }
    case GROUP_CLAUSE_ADDED: {
      const [lastClause] = getLeafNodes(conditions).slice(-1);
      const [lastClauseType] = Object.keys(lastClause);
      return {
        [groupType]: [
          ...clauses,
          {
            [groupType]: [{ [lastClauseType]: {} }],
          },
        ],
      };
    }
    case GROUP_UNGROUPED:
      return clauses;
    case GROUP_DELETED:
      return null;
    default:
      return conditions;
  }
};
